module.exports = __webpack_public_path__ + "img/background-1.0a87778a.jpg";